/* eslint-disable ember/no-computed-properties-in-native-classes */
import School from '@linc-technologies/linced-common/models/school';
import { computed } from '@ember/object';
import type { Type } from '@warp-drive/core/types/symbols';
import { hasMany, type AsyncHasMany } from '@warp-drive/legacy/model';
import CountryCode from '@linc-technologies/linced-common/enums/country-code';
import Feature from '@linc-technologies/linced-common/enums/feature';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import { resolved } from '@linc-technologies/linced-common/utils/arrays';
import type Person from 'linced-admin/models/person';
import type Set from 'linced-admin/models/school-options/set';
import type Group from 'linced-admin/models/schools/group';

export default class _School extends School {
  declare [Type]: 'school';

  @hasMany('school-options/set', { async: true, inverse: null })
  // @ts-expect-error the admin model makes the common attr a relationship.
  declare optionSetIds: AsyncHasMany<Set>;

  @computed('optionSetIds.content.[]')
  get optionSetsArray() {
    return resolved(this.optionSetIds);
  }

  @hasMany('person', { async: true, inverse: null })
  // @ts-expect-error the admin model makes the common attr a relationship.
  declare supportPersonIds: AsyncHasMany<Person>;

  @computed('countryCode')
  get countryCodeLabel() {
    return CountryCode.getLabel(this.countryCode);
  }

  @computed('jurisdiction')
  get jurisdictionLabel() {
    return Jurisdiction.getLabel(this.jurisdiction);
  }

  @computed('featuresEnabled')
  get hasBilling() {
    return this.featuresEnabled.includes(Feature.PUPIL_BILLING);
  }

  @computed('featuresEnabled')
  get hasSuite() {
    return this.featuresEnabled.includes(Feature.SUITE);
  }

  @computed('featuresEnabled')
  get hasPremier() {
    return this.featuresEnabled.includes(Feature.PREMIER);
  }

  @hasMany('schools/group', { async: true, inverse: 'schoolIds' })
  declare groups: AsyncHasMany<Group>;
}
